
export enum SecurityContextType {
    None = 0,
    System = 1,
    Organization = 2,
    Program = 4,
    Course = 8,
    Class = 16,
    Group = 32,
    User = 64,
    Activity = 128,
    ActivityIncomplete = 129,
    MasterCourse = 256,
    Term = 512
}